import gsap from 'gsap'
import Base from '../../../src/js/classes/Base'

export default class ContactForm extends Base {
	constructor(el) {
		super({
			element: el,
			elements: {
				closes: '.c-ContactForm__controls__close',
			},
			options: {},
			classes: {
				contactOpen: 'contact-open',
			},
			state: {},
		})
	}

	init() {
		this.elements.closes = gsap.utils.toArray(this.elements.closes)
		this.addEvents()
	}

	addEvents() {
		this.elements.closes.forEach((close) => {
			close.addEventListener('click', this.onClickClose.bind(this))
		})
	}

	onClickClose(e) {
		e.preventDefault()
		document.body.classList.remove(this.classes.contactOpen)
	}

	removeEvents() {
		this.elements.closes.forEach((close) => {
			close.removeEventListener('click', this.onClickClose.bind(this))
		})
	}

	resize() {}

	update() {}

	unmount() {
		this.removeEvents()
	}
}
